/**
 * Description  管理配置 日志管理 在线人数
 * rebuild:zhang.qiang 2017-4-18
 */
'use strict';
angular.module('logManageMentOnlineUsersModule', [
    'logManageMentOnlineUsersRouterModule',
])
    .controller('logManageMentonlineUsersCtrl', ['$scope', 'trsHttpService', '$interval',
        function($scope, trsHttpService, $interval) {
            initStatus();
            initData();

            /**
             * [initStatus description] 状态初始化
             */
            function initStatus() {
                $scope.status = {
                    showNumber: '',
                    timer: '',
                    copyCurrPage: '',
                };
                $scope.data = {
                    items: [],
                };
            }

            /**
             * [initData description] 数据初始化
             */
            function initData() {
                requestData();
                autoRefresh();
            }

            /**
             * [requestData description] 请求数据
             */
            function requestData() {
                var params = {
                    'serviceid': 'mlf_extuser',
                    'methodname': 'queryOnlineUsers',
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    $scope.data.items = data.ONLINEUSERS;
                    $scope.status.showNumber = data.ONLINEUSERCOUNT;
                });
            }

            /**
             * [refresh 刷新]
             * @return {[type]} [description]
             */
            $scope.refresh = function() {
                requestData();
            };

            /**
             * [autoRefresh 定时2分钟刷新一次]
             * @return {[type]} [description]
             */
            function autoRefresh() {
                if ($scope.status.timer) {$scope.status.timer = null;}
                $scope.status.timer = $interval(function() {
                    requestData();
                }, 1000 * 60 * 2);
            }

            /**
             * [离开页面销毁定时器]
             * @param  {[type]} ){                             if ($scope.status.timer) $scope.status.timer [description]
             * @return {[type]}     [description]
             */
            $scope.$on('$destroy', function() {
                if ($scope.status.timer) {$scope.status.timer = null;}
            });
        }
    ]);
